<div class="exp" @item>
  <div class="checkbox">
    <div>
      <input type="checkbox" [id]="id" [(ngModel)]="isSelected" (click)="selectByClick()" />
      <label [for]="id"><span [ngClass]="extraClass"></span></label>
    </div>
  </div>
</div>
